import React, {Fragment, useContext, useEffect, useState} from 'react';
import {Typography, Button, Snackbar} from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from "@material-ui/core/TableRow";
import Checkbox from '@material-ui/core/Checkbox';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import StarIcon from '@mui/icons-material/Star';
import Axios from "axios";
import PopOverCustom from "../../../../../components/PopOver";
import {useHistory} from "react-router-dom";
import {useIsMount} from "../../../../useIsMount";
import useStyles from './styles';
import formInitialValues from "../../../Emision/VehiculoForm/Checkout/FormModel/formInitialValues";
import {Modal} from "rsuite";
import Loading from "../../../../Loading";
import UserContext from "../../../../../context/UserContext";
import Alert from "@material-ui/lab/Alert";

const FileDownload = require('js-file-download');
const moment = require('moment');


function CotizacionSuccess(props) {
    const customerData = props.customerData;
    const classes = useStyles();
    const {finalValues, cotizacionResponse} = props;
    const [selected, setSelected] = useState([12, 14, 18]);
    const [starred, setStarred] = useState([12]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorRow, setAnchorRow] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const isMount = useIsMount();
    const [modalOpen, setModalOpen] = useState(false);
    //SNACKBAR ALERT
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [alertMessageSnackBar, setAlertMessageSnackBar] = useState(null);
    const descuentoEspecial = props.descuentoEspecial;
    const [displayPlans, setDisplayPlans] = useState(cotizacionResponse.plans);

    useEffect(() => {
        if (descuentoEspecial > 0) {
            const plans = props.cotizacionResponse.plans.map(plan => ({
                ...plan,
                premium: plan.premium - (plan.premium * descuentoEspecial / 100),
            }));
            setDisplayPlans(plans);
        }
    }, [descuentoEspecial, props.cotizacionResponse]);

    const headCells = [
        {id: 'moduleSancor', numeric: true, disablePadding: true, label: 'Módulo'},
        {id: 'description', numeric: false, disablePadding: false, label: 'Descripción'},
        {id: 'outStandard', numeric: false, disablePadding: true, label: 'Fuera de Norma'},
        {id: 'premium', numeric: true, disablePadding: false, label: 'Premio'},
        {id: 'starred', numeric: false, disablePadding: false, label: 'Destacar'},
        {id: 'actions', numeric: false, disablePadding: false, label: 'Acciones'}
    ];

    const handleMenuClick = (event, row) => {
        setAnchorEl(event.currentTarget);
        setAnchorRow(row);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setAnchorRow(null);
    };

    const ajusteAutomaticoOptions = {
        "0" : "0",
        "10" : "Option_10",
        "20" : "Option_20",
        "30" : "Option_30",
    }

    const handleEmsion = () => {
        let emisionValues = formInitialValues;
        emisionValues.premium = anchorRow.premium;

        emisionValues.nombreModulo = anchorRow.description;
        emisionValues.moduloCobertura = anchorRow.moduleSancor;
        emisionValues.descuentoExtra = finalValues.descuentoExtra;
        emisionValues.descuentoEspecial = props.descuentoEspecial;
        emisionValues.vehiculo = {
            ...emisionValues.vehiculo,
            ...finalValues.vehiculo
        };
        emisionValues.vehiculo.tipoUso = finalValues.vehiculo.usoVehiculo;
        emisionValues.vehiculo.valor = cotizacionResponse['vehicleValuation'];
        emisionValues.vehiculo.equipoDeRastreo = anchorRow.trackingEquipment;
        emisionValues.vehiculo.patente = finalValues.patente;
        emisionValues.vigenciaDesde = finalValues.fechaCotizacion;
        if (finalValues.vehiculo.tieneGnc === '1'){
            emisionValues.vehiculo.tieneGnc = 'true'
            emisionValues.vehiculo.gnc.valorTotal = finalValues.vehiculo.valorGnc.toString();
        }
        else{
            emisionValues.vehiculo.tieneGnc = 'false'
            emisionValues.vehiculo.gnc.valorTotal = '0'
        }
        emisionValues.clientes[0].nombre = finalValues.nombre;
        emisionValues.clientes[0].apellido = finalValues.apellido;
        if (finalValues.dni !== undefined)
            emisionValues.clientes[0].dni = finalValues.dni.toString();
        else
            emisionValues.clientes[0].dni = finalValues.dni
        emisionValues.clientes[0].telefono = finalValues.telefono;
        emisionValues.clientes[0].email = finalValues.email;
        emisionValues.clientes[0].codigosLocalidad = finalValues.codigosLocalidad;
        emisionValues.clientes[0].situacionIva = finalValues.situacionImpositiva;
        emisionValues.clientes[0].personaJuridica = finalValues.personaJuridica;
        emisionValues.frecuenciaPago = finalValues.frecuenciaPago;
        emisionValues.afinidad = finalValues.afinidad;
        if (emisionValues.frecuenciaPago === '7') {
            emisionValues.cuotas = finalValues.cuotas;
            emisionValues.ajusteAutomatico = ajusteAutomaticoOptions[finalValues.ajusteAutomatico];
            emisionValues.vigenciaHasta = moment().add(6, "M").format("YYYY-MM-DD");
        }
        emisionValues.bienesAsegurados = []

        //Nuevos datos para eliminar y agregar comentarios a las cotizaciones
        emisionValues.outStandard = anchorRow.outStandard;
        emisionValues.outStandardSancor = anchorRow.outStandardSancor;
        emisionValues.idCotizacion = cotizacionResponse.cotizacionId;

        if (descuentoEspecial > 0) {
            emisionValues.comentariosSolicitud = `Favor de emitir cobertura ${anchorRow.description} con descuento adicional del ${descuentoEspecial}%, para llegar al valor cuota de $${anchorRow.premium}.`
        }

        history.push({
            pathname: "/u/emitir/vehiculo",
            state: {
                emisionValues: emisionValues,
                recotizar: finalValues.recotizar
            }
        })
    };

    const Mailto = ({email, subject = '', body = '', children}) => {
        let params = subject || body ? '?' : '';
        if (subject) params += `subject=${encodeURIComponent(subject)}`;
        if (body) params += `${subject ? '&' : ''}body=${encodeURIComponent(body)}`;

        return <a href={`mailto:${email}${params}`}>{children}</a>;
    };

    const sendWapp = (customerData) => {
        let url;
        // TODO: Remove conditional, the right one will be the one with splitted field
        if (customerData.CodArea !== null && customerData.CodArea !== undefined)
            url = "https://wa.me/" + "549" + customerData.CodArea + customerData.Telefono + "?text=¡Buenos%20días%20" + customerData.Nombre + "!%20Le%20comparto%20la%20información%20de%20la%20cotización%20solicitada.%20Cualquier%20consulta,%20no%20dude%20en%20escribirme.%20Saludos!";
        else
            url = "https://wa.me/" + "549" + customerData.Telefono + "?text=¡Buenos%20días%20" + customerData.Nombre + "!%20Le%20comparto%20la%20información%20de%20la%20cotización%20solicitada.%20Cualquier%20consulta,%20no%20dude%20en%20escribirme.%20Saludos!";

        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    const handleStarred = (event, name) => {
        if (starred.indexOf(name) === -1)
            setStarred([name]);
        else
            setStarred([]);
    };

    const {userName, userPicture, userId, userPhone, userProvince, userMail} = useContext(UserContext)

    function comparePlans() {
        const selectedPlans = selected.map((displayPlan) => {
            return displayPlans.find(p => p.moduleSancor === displayPlan);
        }, []);

        let jsonData = {
            'marca': finalValues.vehiculo.detalle_marca,
            'modelo': finalValues.vehiculo.detalle_version,
            'gnc': finalValues.vehiculo.tieneGnc,
            'year': finalValues.vehiculo.anio,
            'uso': cotizacionResponse['vehicleUse'],
            'valor': cotizacionResponse['vehicleValuation'],
            'adicionales': cotizacionResponse['aditionalValues'],
            'fecha': finalValues['fechaCotizacion'],
            'num_cotizacion': cotizacionResponse['cotizacionId'],
            'cod_postal': cotizacionResponse['codigoPostal'],
            'localidad': cotizacionResponse['codigoLocalidad'],
            'img_src': userPicture,
            'nombre': userName,
            'telefono': userPhone,
            'mail': userMail,
            'provincia': userProvince,
            'selectedPlans': selectedPlans,
            'starredPlan': starred,
            'id_Auth': userId,
            'img_afinidad': finalValues.img_afinidad,
            'nombre_cliente': finalValues.nombre ? finalValues.nombre + " " + finalValues.apellido : "",
            'dni': finalValues.dni ? finalValues.dni : "",
            'patente': finalValues.patente ? finalValues.patente : ""
        }

        if (finalValues.vigencia === "2") jsonData['numeroCuotas'] = finalValues.cuotas
        else jsonData['numeroCuotas'] = ""


        //TODO: obtener la matricula correcta
        jsonData['matricula'] = ''
        jsonData['matriculaMaster'] = ''

        Axios.post(process.env.REACT_APP_BACK_SERVER + '/templateAutomotor', jsonData, {responseType: 'blob'})
            .then((response) => {
                FileDownload(response.data, 'cotizacion.pdf');
                setIsLoading(false);
                setModalOpen(!modalOpen)
            })
            .catch((error) => {
                setOpenSnackBar(true)
                setAlertMessageSnackBar("Ha ocurrido un error, intente nuevamente más tarde")
                setIsLoading(false);
                console.log(error);
            });

    }


    useEffect(() => {
        if (isMount) {
            selected.forEach(e => {
                const foundPlan = cotizacionResponse['plans'].find(i => i.moduleSancor === e);
                if (!foundPlan) {
                    setSelected(prevState => [...prevState.filter(sel => sel !== e), cotizacionResponse['plans'][0]['moduleSancor']])
                }
            });
        }
    }, []);

    const isSelected = (name) => selected.indexOf(name) !== -1;
    const isStarred = (name) => starred.indexOf(name) !== -1;

    return (
        <React.Fragment>
            <Fragment>
                <div style={{display: "flex", flexDirection: "row"}}>
                    <div style={{display: "flex", flexDirection: "column"}}>
                        <p className={classes.cotSuccTitle}>Detalle del producto</p>
                        <p className={classes.cotSuccAuto}>{finalValues.vehiculo.detalle_marca} {finalValues.vehiculo.detalle_version}</p>
                        <p className={classes.cotSuccValor}>Valor: <span
                            style={{fontWeight: "Bold"}}>${cotizacionResponse['vehicleValuation']}</span></p>
                        <p className={classes.cotSuccValor}>Capital Asegurable Total: <span
                            style={{fontWeight: "Bold"}}>${cotizacionResponse['vehicleValuation'] + cotizacionResponse['aditionalValues']}</span>
                        </p>
                    </div>
                </div>
                <div className={classes.cotSuccTable}
                     style={{display: "flex", flexDirection: "row", marginTop: "20px"}}>
                    <TableContainer>
                        {cotizacionResponse['plans'].length !== 0 && (
                            <Table>
                                <TableHead>
                                    <TableRow style={{backgroundColor: "#9A9A9A"}}>
                                        <TableCell/>
                                        {headCells.map((headCell) => (
                                            <TableCell
                                                key={headCell.id}
                                                align={headCell.numeric ? 'right' : 'left'}
                                                padding={headCell.disablePadding ? 'none' : 'default'}
                                            >
                                                {headCell.label}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {displayPlans.map((row, index) => {
                                        const isItemSelected = isSelected(row.moduleSancor);
                                        const isItemStarred = isStarred(row.moduleSancor);
                                        const labelId = `table-checkbox-${index}`;
                                        const starId = `table-star-checbox-${index}`;

                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                aria-checked={isItemSelected}
                                                tabIndex={-1}
                                                key={row.moduleSancor}
                                                selected={isItemSelected}
                                            >
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        checked={isItemSelected}
                                                        inputProps={{'aria-labelledby': labelId}}
                                                        onClick={(event) => handleClick(event, row.moduleSancor)}
                                                    />
                                                </TableCell>
                                                <TableCell component="th" id={labelId} scope="row" padding="none">
                                                    {row.moduleSancor}
                                                </TableCell>
                                                <TableCell align="left">{row.description}</TableCell>
                                                <TableCell align="left">
                                                    <div
                                                        style={row.outStandardSancor === 'true' ? {display: 'flex'} : {display: 'none'}}
                                                        className={classes.textContainerCotSucc}
                                                    >
                                                        <Typography
                                                            variant="button"
                                                            className={classes.outStandardTextCotSucc}
                                                            align="center"
                                                        >
                                                            Fuera de pauta.
                                                        </Typography>
                                                    </div>
                                                </TableCell>
                                                <TableCell align="right">${row.premium}</TableCell>
                                                <TableCell>
                                                    <Checkbox
                                                        icon={<StarBorderIcon/>}
                                                        checkedIcon={<StarIcon/>}
                                                        checked={isItemStarred}
                                                        inputProps={{'aria-labelledby': starId}}
                                                        onChange={(event) => handleStarred(event, row.moduleSancor)}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <Button
                                                        aria-controls="simple-menu"
                                                        aria-haspopup="true"
                                                        onClick={(event) => handleMenuClick(event, row)}
                                                    >
                                                        <ArrowDropDownCircleIcon/>
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        )}
                    </TableContainer>
                    <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                    >

                        <MenuItem onClick={handleEmsion}>Contratar</MenuItem>
                        <MenuItem onClick={handleMenuClose}>
                            <Mailto
                                body=''
                                subject='Pedido especial de descuento y/o cobertura'
                                email='mbollati@prevencionart.com.ar; cborga@sancorseguros.com'
                            >
                                Excepción
                            </Mailto>
                            <PopOverCustom descripcion={'Con este boton podes pedir una excepcion'}/>
                        </MenuItem>
                    </Menu>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "center"}}>


                    <div className={classes.buttonsCotSucc}>
                        {(selected.length === 3) &&
                        (<Button
                            onClick={() => {
                                setIsLoading(true);
                                comparePlans()
                            }}
                            variant='contained'
                            color="primary"
                            className={classes.buttonContainedCotSucc}
                        >
                            Comparar
                        </Button>)
                        }
                    </div>
                </div>
            </Fragment>

            <Modal backdrop={true} show={modalOpen} onHide={() => setModalOpen(!modalOpen)} style={{top: '10%'}}>
                <Modal.Header>

                </Modal.Header>
                <Modal.Body>
                    {customerData ?
                        <div className={classes.modalColumn}>
                            <p className={classes.modalTitle} style={{marginBottom: "20px"}}>Compartir esta
                                cotización</p>
                            <div>
                                <Mailto email={customerData.Email} subject="La cotización de su seguro está lista"
                                        body={"¡Buenos días " + customerData.Nombre + "! Le comparto la información de la cotización que ha solicitado. Cualquier consulta, quedo a su disposición. Saludos."}>
                                    <button className={classes.btnShare}>
                                        Compartir vía Email
                                    </button>
                                </Mailto>

                                <button className={classes.btnShare} onClick={
                                    () => sendWapp(customerData)}>
                                    Compartir vía WhatsApp
                                </button>
                            </div>

                        </div> :

                        <div className={classes.modalColumn}>
                            <p className={classes.modalTitle} style={{marginBottom: "20px"}}>Compartir esta
                                cotización</p>
                            <p>No hay datos del usuario</p>

                        </div>
                    }

                </Modal.Body>
            </Modal>

            {isLoading ? <div className={classes.loadingDiv}><Loading/></div> : <div/>}
            <Snackbar open={openSnackBar && alertMessageSnackBar} autoHideDuration={5000} onClose={() => {
                setOpenSnackBar(false);
                setAlertMessageSnackBar(null);
            }}>
                <Alert onClose={() => {
                    setOpenSnackBar(false);
                    setAlertMessageSnackBar(null);
                }} severity="warning" elevation={6} variant="filled"
                       classes={{filledWarning: classes.snackBar}}
                >
                    {alertMessageSnackBar}
                </Alert>
            </Snackbar>


        </React.Fragment>
    );
}

export default CotizacionSuccess;
